<template>
  <div class="date-component">
    <div class="date-picker-body inline-block">
      <div class="mr-10 inline-block">
        {{ $t('text.chart_date') }}
      </div>
      <el-select
        v-model="activeQuickRange"
        size="small"
        @change="handleQuickRange"
      >
        <el-option
          v-for="option in quickRangeOptions"
          :key="option.value"
          :label="option.label"
          :value="option.value"
        />
      </el-select>
      <div v-if="activeQuickRange === 'custom'" class="custom-body">
        <div class="mr-10 inline-block" style="visibility: hidden;">
          {{ $t('text.chart_date') }}
        </div>
        <el-date-picker
          v-model="date"
          type="datetimerange"
          format="dd/MM/yy HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="to"
          :start-placeholder="$t('text.start_time')"
          :end-placeholder="$t('text.end_time')"
          :clearable="false"
          :unlink-panels="true"
          popper-class="public-date-poper"
          :picker-options="pickerOptions"
          @change="handleDateChange"
          size="small"
        >
        </el-date-picker>
      </div>
    </div>
    <UtcOffsets />
  </div>
</template>

<script>
import UtcOffsets from '@/components/UtcOffsets'
import moment from 'moment'
export default {
  data() {
    return {
      activeQuickRange: this.$store.state.pods.selectedDateQuickAction,
      date: this.$store.state.pods.selectedDate,
      pickerMinDate: null,
      day7: 7 * 24 * 3600 * 1000 - 1,
      pickerOptions: {
        onPick: time => {
          if (time.minDate && this.pickerMinDate) {
            this.pickerMinDate = null
          } else if (time.minDate) {
            this.pickerMinDate = time.minDate.getTime()
          }
        },
        disabledDate: time => {
          if (this.pickerMinDate) {
            return (
              time.getTime() > this.pickerMinDate + this.day7 ||
              time.getTime() < this.pickerMinDate - this.day7 ||
              time.getTime() > Date.now() ||
              time.getTime() === this.pickerMinDate
            )
          } else {
            return time.getTime() > Date.now()
          }
        }
      },
      quickRangeOptions: [
        { label: 'Last 30 mins', value: 'last30' },
        { label: 'Last 1 hour', value: 'last1' },
        { label: 'Last 6 hours', value: 'last6' },
        { label: 'Last 12 hours', value: 'last12' },
        { label: 'Last 24 hours', value: 'last24' },
        { label: 'Custom', value: 'custom' }
      ]
    }
  },
  components: {
    UtcOffsets
  },
  watch: {
    '$store.state.pods.selectedDate': function(newVal) {
      this.date = newVal
    },
    '$store.state.pods.selectedDateQuickAction': function(newVal) {
      this.activeQuickRange = newVal
    }
  },
  methods: {
    applyQuickRange(range) {
      const now = new Date()
      let start = new Date()
      switch (range) {
        case 'last30':
          start = new Date(now.getTime() - 30 * 60 * 1000)
          break
        case 'last1':
          start = new Date(now.getTime() - 60 * 60 * 1000)
          break
        case 'last6':
          start = new Date(now.getTime() - 6 * 60 * 60 * 1000)
          break
        case 'last12':
          start = new Date(now.getTime() - 12 * 60 * 60 * 1000)
          break
        case 'last24':
          start = new Date(now.getTime() - 24 * 60 * 60 * 1000)
          break
        default:
          return
      }
      const formattedStart = moment(start).format('YYYY-MM-DD HH:mm:ss')
      const formattedNow = moment(now).format('YYYY-MM-DD HH:mm:ss')
      this.date = [formattedStart, formattedNow]
      this.$store.commit('pods/SET_SELECTED_DATE', this.date)
      this.$store.commit(
        'pods/SET_SELECTED_DATE_QUICK_ACTION',
        this.activeQuickRange
      )
    },
    handleQuickRange(range) {
      if (range !== 'custom') {
        this.applyQuickRange(range)
      }
    },
    handleDateChange() {
      this.activeQuickRange = 'custom'
      this.$store.commit('pods/SET_SELECTED_DATE', this.date)
      this.$store.commit(
        'pods/SET_SELECTED_DATE_QUICK_ACTION',
        this.activeQuickRange
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.date-component {
  .date-picker-body {
    .custom-body {
      margin-top: 10px;
      .el-range-editor {
        width: 280px;
      }
    }
  }
  .el-select {
    width: 280px;
  }
}
.quick-range-options {
  text-align: right;
  margin-bottom: 10px;
}
</style>
